import img0 from "./Assets/0.png";
import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import img4 from "./Assets/4.png";
import img5 from "./Assets/5.png";
import img6 from "./Assets/6.png";
import img7 from "./Assets/7.png";
import img8 from "./Assets/8.png";
import img9 from "./Assets/9.png";
import img10 from "./Assets/10.png";
import img11 from "./Assets/11.png";
import img12 from "./Assets/12.png";
import img13 from "./Assets/13.png";
import img14 from "./Assets/14.png";
import img15 from "./Assets/15.png";
import logo from "./Assets/qb.png";

export default class QuarterbackBlitzConfig {
    constructor() {
        // Set up the symbol imgs & Logo
        // Make sure to match with imports above
        this.symbolImgs = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15];
        this.logo = logo;

        //Game Name
        this.name = "Quarterback Blitz";

        //General Config
        this.reels = 5;
        this.symbolPerReel = 3;
        this.cascade = false;

        //This is used to invert the symbol IDs (because Aris). Input the highest symbol ID possible in the game.
        //Have left this to be a manual input as sometimes it can work slightly differently depending on game
        this.highestSymId = 0;

        //Ask CROW for the maths object
        this.maths = this.getMaths();
    }

    getMaths() {
        //paste what crow gives you here!
        return {
            94:{
                reductionWeight1M : 10032
            },
            95: {
                weights: {
                    Base: [1],
                    freeSpins: {
                        f: [1]
                    },
                },
                reelSets: {
                    0: [
                        [6, 15, 14, 1, 15, 11, 2, 7, 10, 4, 4, 4, 15, 8, 2, 10, 6, 15, 9, 3, 12, 15, 5, 12, 7, 11, 15, 12, 6, 14, 15, 8, 11, 14, 5, 12, 9, 13, 12, 5, 11, 13, 10, 3, 11, 9, 13, 5, 12, 7, 14, 8, 13, 15, 14],
                        [15, 10, 11, 14, 7, 13, 12, 15, 10, 5, 4, 4, 15, 11, 9, 14, 15, 11, 13, 3, 10, 7, 14, 11, 6, 13, 15, 8, 12, 14, 5, 11, 8, 13, 14, 6, 11, 9, 12, 11, 15, 14, 10, 11, 15, 14, 9, 13, 12, 9, 14, 12, 8, 11, 13, 15, 12, 14],
                        [6, 7, 10, 5, 15, 14, 2, 15, 12, 4, 4, 4, 15, 14, 2, 13, 12, 14, 15, 3, 11, 14, 15, 8, 9, 14, 12, 7, 13, 5, 10, 2, 13, 8, 15, 12, 6, 10, 9, 15, 2, 14, 11, 10, 13, 5, 12, 14, 8, 13, 9, 11, 12, 8, 13, 15, 10, 12, 11, 8, 9, 5, 15, 14, 6, 7, 10],
                        [7, 8, 9, 14, 15, 9, 11, 12, 14, 13, 10, 4, 8, 11, 15, 6, 14, 9, 10, 3, 11, 15, 6, 14, 13, 7, 14, 15, 8, 12, 11, 15, 14, 12, 10, 15, 3, 10, 15, 12, 10, 13, 15, 12, 5, 11, 13, 10, 7, 12, 13, 15, 5, 10, 13],
                        [14, 15, 5, 0, 12, 11, 2, 15, 5, 4, 4, 4, 12, 14, 2, 11, 6, 15, 8, 3, 12, 14, 2, 15, 7, 14, 9, 3, 8, 15, 10, 2, 13, 12, 15, 13, 2, 14, 13, 11, 2, 10, 13, 3, 11, 7, 13, 12, 3, 13, 14, 11, 15, 9, 13],
                    ],
                    f_0: [
                        [10, 7, 11, 6, 2, 13, 6, 12, 4, 4, 4, 15, 8, 14, 5, 11, 14, 8, 10, 6, 12, 10, 8, 15, 5, 12, 13, 7, 9, 14, 6, 7, 13, 5, 10, 7, 9, 9, 13, 2, 9, 11, 5, 12, 0, 1, 7, 0, 9],
                        [10, 11, 5, 6, 11, 8, 10, 5, 6, 4, 15, 14, 7, 8, 12, 9, 13, 7, 9, 14, 7, 6, 11, 8, 12, 13, 4, 14, 12, 4, 15, 13, 5, 15, 12, 14, 10, 11, 13, 12, 6, 7, 14, 8, 6, 0, 8],
                        [11, 6, 7, 9, 5, 15, 11, 4, 4, 4, 11, 12, 9, 13, 2, 14, 8, 13, 7, 12, 10, 6, 11, 2, 5, 12, 7, 15, 6, 9, 8, 13, 11, 9, 5, 10, 12, 4, 14, 10, 2, 4, 15, 8, 1, 0, 9, 10, 1, 9, 3, 13, 10, 2, 5, 6, 7, 5, 8, 1],
                        [12, 9, 14, 6, 12, 13, 7, 8, 4, 4, 5, 13, 11, 15, 6, 10, 9, 8, 11, 5, 14, 10, 7, 11, 6, 9, 8, 14, 13, 4, 10, 12, 5, 15, 12, 4, 10, 15, 13, 9, 7, 15, 14, 5],
                        [8, 13, 9, 2, 12, 15, 11, 9, 5, 4, 4, 4, 12, 14, 9, 2, 10, 13, 6, 7, 13, 5, 10, 2, 14, 13, 11, 15, 14, 6, 7, 8, 15, 2, 11, 12, 15, 11, 7, 14, 2, 15, 8, 10, 8, 9, 10, 1, 8],
                    ],
                },
            },
        };
    }
}
